//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import calendar from '@/tools/date/calendar'

const query = {
  startDate: null,
  endDate: null,
  startTime: null,
  endTime: null
}

export default {
  data: () => ({
    list: calendar(0, 6),
    query: query,
    secondTime: false
  }),
  created () {
    this.initCalendar()
  },
  methods: {
    initCalendar () {
    },
    onDateClick (item) {
      if (!this.query.startDate || this.query.startDate >= item.value) {
        this.clear()
        this.query.startDate = item.value
      } else if (!this.secondTime) {
        this.secondTime = true
        this.query.endDate = item.value
      } else {
        this.secondTime = false
        this.clear()
        this.query.startDate = item.value
      }
      this.resetActive()
    },
    resetActive () {
      for (let m of this.list) {
        for (let item of m.dates) {
          if (item.value >= this.query.startDate && item.value <= this.query.endDate) {
            item.isActive = true
          } else if (item.value === this.query.startDate) {
            item.isActive = true
          } else {
            item.isActive = false
          }
        }
      }
    },
    clear () {
      this.secondTime = false
      this.query = {
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null
      }
    },
    reset () {
      this.clear()
      this.resetActive()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/calendar/index.vue